import { Component, input } from '@angular/core'

@Component({
    selector: 'sf-advert-cta-item',
    host: {
        class: 'advert__item',
    },
    template: `
        <img class="advert__item-image rounded-2 mb-2" [src]="image()" />
        <div class="d-flex flex-column gap-1">
            <ng-content select="sf-advert-cta-item-title" />
            <ng-content select="sf-advert-cta-item-content" />
        </div>
    `,
})
export class AdvertCtaItemComponent {
    image = input<string | null>(null)
}
